import React from "react";

const CountryContext = React.createContext({});

export default CountryContext;
